import {useEffect} from "react";
import {useState} from "@hookstate/core";
import {Link, useParams, Redirect} from 'react-router-dom';
import {Button, Card, CardDeck, Nav, Table, Modal, InputGroup, Form, FormCheck} from "react-bootstrap";
import {
    Link as ScrollLink,
    Element as ScrollElement,
    scroller
} from 'react-scroll'

import {
    getClient,
    getClientAddresses,
    getClientContacts,
    getClientJobs,
    deleteAddress,
    deleteContact,
    formatPhoneNumber,
    formatDate,
    editClient
} from "../../Services/ApiService";
import './ClientDetails.scss';
import EditAddressModal from "./Components/EditAddressModal";
import EditContactModal from "./Components/EditContactModal";

// noinspection JSValidateTypes
function ClientDetails() {
    const apiError = useState(false);
    const {clientId} = useParams();
    const redirect = useState(undefined);

    const retrieved = useState([]);
    const client = useState({});
    const addresses = useState([]);
    const contacts = useState([]);
    const jobs = useState([]);
    // const jobItems = useState([]);

    const editClientName = useState('');
    const editClientIsActive = useState(true);
    const savedNotifIsHidden = useState(true);
    const message = useState("");

    useEffect(() => {
        getClient(clientId, _client => {
            if (_client === false) apiError.set(true);

            client.set(_client[0]);
            editClientName.set(_client[0].name);
            editClientIsActive.set(_client[0].isActive);
            retrieved.set([...retrieved.get(), 'client']);
        });
        updateContacts(() => {
            retrieved.set([...retrieved.get(), 'contacts'])
        })
        updateAddresses(() => {
            retrieved.set([...retrieved.get(), 'addresses']);
        })
        getClientJobs(clientId, (_jobs) => {
            jobs.set(_jobs);
            // jobItems.set(_jobItems);
            retrieved.set([...retrieved.get(), 'jobs']);
        });
        // eslint-disable-next-line
    }, []);

    // <editor-fold desc="Form stuff">
    function updateAddresses(callback) {
        setTimeout(() => {
            getClientAddresses(clientId, _addresses => {
                addresses.set(_addresses);
                callback(true);
            });
        }, 50);
    }

    function updateContacts(callback) {
        setTimeout(_ => {
            getClientContacts(clientId, _contacts => {
                contacts.set(_contacts);
                callback(true);
            });
        }, 50);
    }
    // </editor-fold desc="Form stuff">

    // <editor-fold desc='address stuff'>
    const showEditAddressModal = useState(false);
    const handleShowEditAddressModal = () => showEditAddressModal.set(true);
    const handleCloseEditAddressModal = () => showEditAddressModal.set(false);

    const newAddress = useState({});

    function handleEditAddressClicked(e) {
        if (e.target.id !== '-1') {
            const selectedAddress = addresses.get().filter(add => {
                return add.id.toString() === e.target.id.toString();
            })[0];

            newAddress.set({
                id: selectedAddress.id,
                clientId: client.get().id,
                street: selectedAddress.street,
                street2: selectedAddress.street2,
                city: selectedAddress.city,
                state: selectedAddress.state,
                zip: selectedAddress.zip
            });

            handleShowEditAddressModal();
        } else { // if the id is -1, we're creating a new address
            newAddress.set({
                id: -1,
                clientId: client.get().id,
                street: '',
                street2: '',
                city: '',
                state: '',
                zip: ''
            });

            handleShowEditAddressModal();
        }
    }

    const showDelAddressModal = useState(false);
    const handleShowDelAddressModal = () => showDelAddressModal.set(true);
    const handleCloseDelAddressModal = () => showDelAddressModal.set(false);
    const addressToDelete = useState({});

    function handleDelAddressClicked(e) {
        const selectedAddress = addresses.get().filter(add => {
            return add.id.toString() === e.target.id.toString();
        })[0];
        addressToDelete.set(JSON.parse(JSON.stringify(selectedAddress)));
        handleShowDelAddressModal();
    }

    function handleAddressDeletion() {
        deleteAddress(addressToDelete.get(), () => {
            updateAddresses(() => {});
        });
        handleCloseDelAddressModal();
    }
    // </editor-fold desc='address stuff'>

    // <editor-fold desc='contact stuff'>
    const showEditContactModal = useState(false);
    const handleShowEditContactModal = () => showEditContactModal.set(true);
    const handleCloseEditContactModal = () => showEditContactModal.set(false);

    const showDelContactModal = useState(false);
    const handleShowDelContactModal = () => showDelContactModal.set(true);
    const handleCloseDelContactModal = () => showDelContactModal.set(false);
    const contactToDelete = useState({});

    const newContact = useState({});

    function handleEditContactClicked(e) {
        if (e.target.id !== '-1') {
            let selectedContact = contacts.get().filter(contact => {
                return contact.id.toString() === e.target.id.toString();
            })[0];

            newContact.set({
                clientId: client.get().id,
                email: selectedContact.email,
                name: selectedContact.name,
                phone: selectedContact.phone,
                id: selectedContact.id
            });
            handleShowEditContactModal();
        } else { // if the id is -1, we're creating a new contact
            newContact.set({
                clientId: client.get().id,
                email: '',
                name: '',
                phone: '',
                id: -1
            });
            handleShowEditContactModal();
        }
    }

    function handleDelContactClicked(e) {
        const selectedContact = contacts.get().filter(contact => {
            return contact.id.toString() === e.target.id.toString();
        })[0];
        contactToDelete.set(JSON.parse(JSON.stringify(selectedContact)));
        handleShowDelContactModal();
    }

    function handleContactDeletion() {
        deleteContact(contactToDelete.get(), () => {
            updateContacts(_ => {});
        });
        handleCloseDelContactModal();
    }
    // </editor-fold desc='contact stuff'>

    // <editor-fold desc='modals'>
    // noinspection JSValidateTypes
    function DeleteAddressModal() {
        // noinspection JSValidateTypes
        return <Modal show={showDelAddressModal.get()}
                   onHide={handleCloseDelAddressModal}
                   size={'md'}
                   id={'delAddressModal'} >
                <Modal.Header>
                    <Modal.Title>Delete Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete the address:<br/>
                        <strong>{addressToDelete.get().street}<br/>
                        {addressToDelete.get().city}, {addressToDelete.get().state} {addressToDelete.get().zip}</strong>?<br/><br/>
                        It cannot be undone.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={'danger'} onClick={handleAddressDeletion}>Confirm</Button>
                    <Button onClick={handleCloseDelAddressModal}>Cancel</Button>
                </Modal.Footer>
            </Modal>
    }

    function DeleteContactModal() {
        // noinspection JSValidateTypes
        return <Modal show={showDelContactModal.get()}
                   onHide={handleCloseDelContactModal}
                   size={'md'}
                   id={'delContactModal'} >
                <Modal.Header>
                    <Modal.Title>Delete Contact</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Are you sure you want to delete the contact details for<br/>
                        <strong>{contactToDelete.get().name}</strong>?<br/><br/>
                        It cannot be undone.<br /><br /><br />
                        This will <i>not</i> affect jobs attributed to this client.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={'danger'} onClick={handleContactDeletion}>Confirm</Button>
                    <Button onClick={handleCloseDelContactModal}>Cancel</Button>
                </Modal.Footer>
            </Modal>
    }
    // </editor-fold desc='modals'>

    // function displayItems(jobId) {
    //     return <td className={'items'}>
    //         {jobItems.get().filter(item => {
    //             return item.jobId === jobId;
    //         }).map((item, idx) => {
    //             return <p key={idx}>{item.title}</p>
    //         })}
    //     </td>
    // }

    const editBoxFocus = useState(false);

    function ScrollToEnd() {
        scroller.scrollTo('editSection', {
            duration: 1000,
            delay: 0,
            smooth: 'easeInOutQuart',
            offsetTop: 0
        });

        editBoxFocus.set(true);
    }

    function OnEditClientSubmit() {
        editClient({
            clientId: client.get().id,
            clientName: editClientName.get(),
            isActive: editClientIsActive.get(),
            isTaxExempt: client.get().isTaxExempt,
            salesman: client.get().salesman
        }, res => {
            if (!res.success) {
                message.set(res.message);
            } else {
                message.set("");

                // noinspection JSUnresolvedFunction
                client.name.set(editClientName.get());
                savedNotifIsHidden.set(false);

                setTimeout(() => {
                    savedNotifIsHidden.set(true);
                }, 3000)
            }
        });
    }

    if (apiError.get()) {
        return <h4>Something went wrong...</h4>;
    }

    if (retrieved.get().length < 4) {
        return <p>Loading...</p>;
    } else {
        // noinspection JSValidateTypes,JSUnresolvedReference
        return (
            <div className='clientDetails'>
                <div id={'info'}>
                    <h3>Details for {client.get().name}</h3>
                    <FormCheck id={'taxExemptInfo'} label={"Tax Exempt"} checked={client.get().isTaxExempt} disabled />
                    <FormCheck id={'taxExemptInfo'} label={"Active"} checked={client.get().isActive} disabled />
                    <ScrollLink className={'Link'} onClick={() => ScrollToEnd()} to={'editClientForm'}>Edit client details</ScrollLink>
                </div>
                <p>Default Salesman: <u>{client.get().salesman}</u></p>

                {/* <editor-fold desc="Addresses section"> */}
                <h4>Addresses</h4>
                {addresses.get().length === 0 ? (
                    <div className="addresses">
                        <p>No addresses found for {client.get().name}.</p>
                    </div>
                ) : (
                    <CardDeck id={'addresses'}>
                        {addresses.get().map(address => {
                            return (
                                <Card key={address.id}>
                                    <Card.Body>
                                        <Card.Text>
                                            {address.street} <br/>
                                            {address.street2 !== '' && <>{address.street2} <br/></>}
                                            {address.city !== "" ? address.city + "," : ""} {address.state} {address.zip}
                                        </Card.Text>
                                    </Card.Body>
                                    <Card.Footer className={'text-right'}>
                                        <Button onClick={handleEditAddressClicked} id={address.id} className={'mr-1'}>Edit</Button>
                                        <Button onClick={handleDelAddressClicked} id={address.id} variant={"danger"}>Delete</Button>
                                    </Card.Footer>
                                </Card>
                            )
                        })}
                    </CardDeck>
                )}
                <Card>
                    <Card.Body className={'addNewButtonCard'}>
                        <Button onClick={handleEditAddressClicked} id={'-1'}>Add New Address</Button>
                    </Card.Body>
                </Card>
                {/* </editor-fold desc="Addresses section"> */}
                <hr/>

                {/* <editor-fold desc="Contacts section"> */}
                <h4>Contacts</h4>
                {contacts.get().length === 0 ? (
                    <div className="clientContacts">
                        <p>No contacts found for {client.get().name}.</p>
                    </div>
                ) : (
                    <CardDeck id={'contacts'}>
                        {contacts.get().map(contact => {
                            return (
                                <Card className="contactBlock" key={contact.id}>
                                    <Card.Body>
                                        <Card.Title>{contact.name}</Card.Title>
                                        <Card.Text>
                                            Phone: <a href={`tel:${contact.phone}`}>{formatPhoneNumber(contact.phone)}</a><br/>
                                            Email: <a href={`mailto:${contact.email}`}>{contact.email}</a>
                                        </Card.Text>
                                    </Card.Body>
                                    <Card.Footer className={'text-right'}>
                                        <Button onClick={handleEditContactClicked}
                                                id={contact.id}
                                                className={'mr-1'}>Edit</Button>
                                        <Button onClick={handleDelContactClicked}
                                                id={contact.id}
                                                variant={"danger"}>Delete</Button>
                                    </Card.Footer>
                                </Card>
                            )
                        })}
                    </CardDeck>
                )}
                <Card>
                    <Card.Body className={'addNewButtonCard'}>
                        <Button onClick={handleEditContactClicked} id={'-1'}>Add New Contact</Button>
                    </Card.Body>
                </Card>
                {/* </editor-fold desc="Contacts section"> */}
                <hr/>

                {/* <editor-fold desc="jobs section"> */}
                <h4>Jobs</h4>
                {jobs.get() === undefined || jobs.get().length === 0 ? (
                    <div className="clientJobs">No jobs found for {client.get().name}.</div>
                ) : (
                    <div className="jobs">
                        <Table id='jobsTable' bordered size={'sm'}>
                            <thead>
                                <tr>
                                    <th id={'jobNumber'}>Job Number</th>
                                    <th id={'jobQuantity'}>Quantity</th>
                                    <th>Job Description</th>
                                    <th>Date Due</th>
                                </tr>
                            </thead>
                            <tbody>
                            {jobs.get().map((job, idx) => {
                                // noinspection JSValidateTypes
                                return (
                                    <tr key={idx}>
                                        <td id={'number'}><Nav.Link as={Link} to={`/job/${job.id}`}>
                                            {job.jobNumber === -1 ? "Estimate" : job.jobNumber}
                                        </Nav.Link></td>
                                        <td id={'quantity'}>{job.quantity}</td>
                                        <td id={'jobInfo'}>{job.itemInfo}</td>
                                        <td id={'dateDue'}>{formatDate(job.dateDue)}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                    </div>
                )}
                {/* </editor-fold desc="jobs section"> */}
                <hr/>

                {/* <editor-fold desc="Client editing section"> */}
                <div id={'editClientForm'}>
                    <ScrollElement name={'editSection'}>
                        <h4>Edit Client</h4>
                        <InputGroup id={'editName'}>
                            <InputGroup.Text>Client Name</InputGroup.Text>
                            <Form.Control id={'customerPO'}
                                          onChange={e => editClientName.set(e.target.value)}
                                          value={editClientName.get()}
                                          autoFocus={editBoxFocus.get()}
                            />
                        </InputGroup>
                        <InputGroup id={'salesman'}>
                            <InputGroup.Text>Default Salesman</InputGroup.Text>
                            <Form.Control id={'salesmanInput'}
                                          onChange={e => client.salesman.set(e.target.value)}
                                          value={client.get().salesman}
                            />
                        </InputGroup>
                        <FormCheck id={'isActiveCheck'}
                                   label={'Client is Active'}
                                   checked={editClientIsActive.get()}
                                   onChange={e => editClientIsActive.set(e.target.checked)}
                        />

                        <FormCheck id={'isTaxExemptCheck'}
                                   label={"Tax Exempt"}
                                   checked={client.get().isTaxExempt}
                                   onChange={e => client.isTaxExempt.set(e.target.checked)} />

                        <p id={'isActiveNote'}>*An inactive client will not show up in the client list when creating a new job.</p>
                        <div id={'formSubmission'}>
                            <Button type={'submit'} onClick={() => OnEditClientSubmit()}>Save Changes</Button>
                            <p id={`savedNotification-${savedNotifIsHidden.get()}`}>Changes Saved!</p>
                            <p id={'warning'} className={'alert-danger'}>{message.get()}</p>
                        </div>
                    </ScrollElement>
                </div>
                {/* </editor-fold desc="Client editing section"> */}

                {/* <editor-fold desc="Other stuff"> */}
                <div style={{display: 'none'}} id={'modals'}>
                    <EditAddressModal show={showEditAddressModal.get()}
                                      handleShow={handleShowEditAddressModal}
                                      handleClose={handleCloseEditAddressModal}
                                      newAddress={newAddress}
                                      updateAddresses={updateAddresses}
                    />

                    <EditContactModal show={showEditContactModal.get()}
                                      handleShow={handleShowEditContactModal}
                                      handleClose={handleCloseEditContactModal}
                                      newContact={newContact}
                                      updateContacts={updateContacts}
                    />

                    <DeleteAddressModal />
                    <DeleteContactModal />
                </div>
                {redirect.get() && <Redirect to={redirect.get()} />}
                {/* </editor-fold desc="Other stuff"> */}
            </div>
        );
    }
}

export default ClientDetails;